export default {
	questions_about_the_program_find_yout_answers_here: "Des doutes sur le programme? Trouvez vos réponses ici."
}
